import script from "./WorkSkullcandy.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkSkullcandy.vue?vue&type=script&setup=true&lang=js"

import "./WorkSkullcandy.vue?vue&type=style&index=0&id=e33bcc54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33bcc54"]])

export default __exports__